import client from '@/api/server';
import { ActionContext } from '@/store/types';
import { State } from '..';
import { Tournaments, Tournament } from '@/components/Sport/types';
import { NavigationState, NavigationContext, BackgroundOptions } from './types';
import { Route } from 'vue-router';

const navigationContextStack: NavigationContext[] = [];

export const stateNav = {
  drawerOpen: true,

  drawerHidden: true,

  mainBlurred: false,

  background: {
    url: 'https://supersport.azureedge.net/web-assets/placeholder.png',
    type: 'home',
  } as BackgroundOptions,

  navigationState: {
    sport: undefined,
    tournament: undefined,
    contextMenu: undefined,
  } as NavigationState,

  navigationContext: undefined as NavigationContext | undefined,

  tournaments: {},

  selectedTournament: {} as Tournament,
};

export const mutationsNav = {
  setDrawerOpen(state: State, open: boolean) {
    state.drawerOpen = open;
  },
  setDrawerHidden(state: State, hide: boolean) {
    state.drawerHidden = hide;
  },
  setMainBlurred(state: State, blurred: boolean) {
    state.mainBlurred = blurred;
  },
  setTournaments(state: State, tournaments: Tournaments) {
    state.tournaments = tournaments;
  },
  setNavigationState(state: State, currentState: NavigationState) {
    state.navigationState = currentState;
  },
  setBackgroundOptions(state: State, options: BackgroundOptions) {
    state.background = options;
  },
  pushNavigationContext(state: State) {
    const context = {
      route: state.navigationState.route,
      sport: state.navigationState.sport,
      tournament: state.navigationState.tournament,
      contextMenu: state.navigationState.contextMenu,
      activeElement: [document.activeElement]  as [HTMLElement],
    };
    navigationContextStack.push(context);
  },
  popNavigationContext(state: State) {
    state.navigationContext = navigationContextStack.pop();
  },
  setSelectedTournament(state: State, tournament: Tournament) {
    state.selectedTournament = tournament;
  },
};

export const actionsNav = {
  setDrawerOpenState(
    context: ActionContext,
    payload: [boolean],
  ) {
    const [ open ] = payload;
    context.commit('setDrawerOpen', open);
  },

  setDrawerHidden(
    context: ActionContext,
    payload: [boolean],
  ) {
    const [ hide ] = payload;
    context.commit('setDrawerHidden', hide);
  },

  setMainBlurred(
    context: ActionContext,
    payload: [boolean],
  ) {
    const [ blurred ] = payload;
    context.commit('setMainBlurred', blurred);
  },

  async fetchNavigation(context: ActionContext) {
    const tournaments = await client.fetchNavigation();
    context.commit('setTournaments', tournaments);
  },

  setCurrentSport(context: ActionContext, payload: [string?]) {
    const [ sportFeedId ] = payload;
    context.commit('setNavigationState', {
      ...context.state.navigationState,
      sport: sportFeedId,
    });
  },

  setCurrentTournament(context: ActionContext, payload: [string?]) {
    const [ tournamentFeedId ] = payload;
    context.commit('setNavigationState', {
      ...context.state.navigationState,
      tournament: tournamentFeedId,
    });
  },

  setCurrentContextMenu(context: ActionContext, payload: [string?]) {
    const [ contextMenu ] = payload;
    context.commit('setNavigationState', {
      ...context.state.navigationState,
      contextMenu,
    });
  },

  setCurrentRoute(context: ActionContext, paylaod: [Route]) {
    const [route] = paylaod;
    context.commit('setNavigationState', {
      ...context.state.navigationState,
      route,
    });
  },

  pushNavigationContext(actionContext: ActionContext) {
    actionContext.commit('pushNavigationContext');
  },

  popNavigationContext(actionContext: ActionContext) {
    actionContext.commit('popNavigationContext');
  },

  setBackgroundOptions(actionContext: ActionContext, payload: [BackgroundOptions]) {
    const [ options ] = payload;
    actionContext.commit('setBackgroundOptions', options);
  },

  setSelectedTournament(actionContext: ActionContext, payload: [Tournament]) {
    const [ tournament ] = payload;
    actionContext.commit('setSelectedTournament', tournament);
  },
};
